import React from 'react';
import ProgressOverview from 'components/ReportCard/ProgressOverview';
import ProgressScoreOverview from 'components/ReportCard/ProgressScoreOverview';
import ReportCardWrapper from 'components/ReportCard/ReportCardWrapper';
import PartnerFeedbackRoot from 'components/ReportCard/RolePlay/PartnerFeedbackRoot';
import LearnerSectionStats from 'components/ReportCard/LearnerSectionStats';
import ELearningPerformance from 'components/ReportCard/Scorm/ELearningPerformance';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const Progress = ({ progressOverview, reportCard, sectionStatistics }) => {
  return (
    <article className="assignment_report">
      <div className="overview">
        <ProgressOverview
          startedAt={progressOverview.startedAt}
          completedAt={progressOverview.completedAt}
        />
        {progressOverview.showScoreOverview && (
          <ProgressScoreOverview
            score={progressOverview.score}
            correctAnswers={progressOverview.correctAnswers}
            totalScorableAnswers={progressOverview.totalScorableAnswers}
          />
        )}
      </div>

      {reportCard.showReportCard && (
        <>
          <h4>{t('progress.report_card.title')}</h4>
          <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
            {t('progress.report_card.description')}
          </Text>
          <ReportCardWrapper
            hasGraderFeedback={reportCard.hasGraderFeedback}
            currentUserId={reportCard.currentUserId}
            currentUserName={reportCard.currentUserName}
            ratings={reportCard.ratings}
            userName={reportCard.userName}
            progressUserId={reportCard.progressUserId}
            answers={reportCard.answers}
            api={reportCard.api}
            isAdmin={reportCard.isAdmin}
            isLearnerView={reportCard.learnerView}
          />
          <PartnerFeedbackRoot />
        </>
      )}

      {reportCard.elearningScores.length > 0 && (
        <ELearningPerformance eLearningScores={reportCard.elearningScores} />
      )}

      {sectionStatistics.canViewLessonAnalytics && (
        <LearnerSectionStats
          sectionViews={sectionStatistics.sectionViews}
          showUserTime={sectionStatistics.showUserTime}
          sectionArray={sectionStatistics.sectionArray}
          totalSectionsTime={sectionStatistics.totalSectionsTime}
        />
      )}
    </article>
  );
};

export default Progress;
